import React from 'react';
import PropTypes from 'prop-types';
import RewrotedTypeahead from '../../utils/rewrotedTypeahead';
import UiComponent from '../UiComponent';

export default class TextAreaAutocomplete extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  componentDidMount() {
    window.fixTextArea();
  }


  changeValue(value) {
    this.props.field.value = value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    return (
      <div className={containerClass}>
        {this.getLabel()}
        <RewrotedTypeahead
          options={this.props.options}
          disabled={this.props.disabled}
          showOptionsWhenEmpty={true}
          maxVisible={10}
          textarea={true}
          inputProps={{autoComplete: "nope"}}
          placeholder={this.getFieldProp('placeholder')}
          customClasses={{
            input: "form-control",
            results: "topcoat-list__container list-group",
            listItem: "topcoat-list__item list-group-item"
          }}
          ref='typeahead'
          onOptionSelected={(value) => {
            this.refs.typeahead.refs.entry.blur();
            this.refs.typeahead.refs.entry.focus();
            this.changeValue(value);
          }}
          onChange={
            e => {
              this.refs.typeahead.refs.entry.blur();
              this.refs.typeahead.refs.entry.focus();
              this.changeValue(e.target.value);
            }
          }
          value={this.getFieldProp('value')}
        />
        {this.getErrors()}
      </div>
    );
  }
}

TextAreaAutocomplete.propTypes = {
  disabled: PropTypes.bool,
  relatedTo: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.object,
  field: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/TextAreaAutocomplete/index.js